export default __webpack_public_path__ + "static/google_Desktop5-dc450180dadcafd5488435b5bbde7667.svg";